import type { FaireProductEntity } from "../../entity_types/product";

export const p_zfnyrj4sq8: FaireProductEntity = {
  token: "p_zfnyrj4sq8",
  type: "product",
  name: "100% Beeswax Dipped Taper Candles | All Natural, Handmade",
  brandToken: "b_94ned2lnmo",
  brandName: "Mo&Co Home",
  imageUrl:
    "https://cdn.faire.com/fastly/03e137a2cbf32b70a8a6e3967c04277b05c2859320180f25cff56708f3c25335.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d542dff47f22b57c96e7cb63c47f9ccbc2a8c77707923658d3a9d8ea0fcf7064.webp",
    "https://cdn.faire.com/fastly/c89b588d0bb8e3ce2637d424f9cc12acf45ba7bfbfb192116db3e4976721fefc.webp",
    "https://cdn.faire.com/fastly/22c84e6756035681f77083185cc62a1618f4fd263d1574a951bfba17eae44fb6.webp",
    "https://cdn.faire.com/fastly/c86659289c41bf23862055d5bce40ecacaa20a60a194b9b8aee6f6c486fad12f.webp",
    "https://cdn.faire.com/fastly/5445f897784c3ac27c0fd7531fd33478fe706b28bded5e1d6fa55903a928d98f.webp",
    "https://cdn.faire.com/fastly/bb46ac9b70a07f9d5fb5772719617641469f19d5774c5714b390b8c00264ed05.webp",
    "https://cdn.faire.com/fastly/87a68809828a73f176708a0c170134f92097181bfac1a2bdf01d87e0c000b791.webp",
    "https://cdn.faire.com/fastly/997d766a63dd9042174926ed446f7d79c11677d674a5b7d27e020002848f423c.webp",
    "https://cdn.faire.com/fastly/04a71f4eae1bc864fd7810eb7e68f1b6237abb419a712c9e6298568b9de0cfeb.webp",
    "https://cdn.faire.com/fastly/b42d7e9ca2f5dc61db50351ad78bc86adb272668a9e047c78b8ed7c0f9bdde3b.webp",
    "https://cdn.faire.com/fastly/ed251f26fc1abf46b18415497b4fe49c0261a699199799350ab9614a753a173d.webp",
    "https://cdn.faire.com/fastly/8df77a5a47e7fd717a059a3af9109c6845d08afd60c9a751fe375c9f8759c2dc.webp",
    "https://cdn.faire.com/fastly/fb0ac8fe18e36c580ac0b6c1387d43e03ff05df47c93a349bacebe3c83c9a1b2.webp",
    "https://cdn.faire.com/fastly/066405aa6739c69bb8292e8282890c17849557664973cbf21ada83e44af92319.webp",
    "https://cdn.faire.com/fastly/12ec9d1f0dbbf32ce4c85f197c4fbf837316f04294c7bf63c51959abfb5f65c7.webp",
    "https://cdn.faire.com/fastly/e9c3e27ed00abce6ae24b246b4a0020db92ea3864177e41904997ad3216ab782.webp",
    "https://cdn.faire.com/fastly/f791e190e87b82450f52728a83abf7ecb3331db66d8f58aaed14e25c7104e460.webp",
    "https://cdn.faire.com/fastly/e96e7dfcec914eb0357cc774e7bad6fa82efa02646a1ad336940e030ae21feb1.webp",
    "https://cdn.faire.com/fastly/ec6ebde261c32264f9be41a881a6c0fd860c3d7f2797c13b4aa134a0853c514f.png",
  ],
  priceDollars: 9.5,
  description:
    "Dipped Beeswax Candles\nTwo Length Options: 10 inches & 14 inches\nSold in pairs\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\n• 100% Beeswax\n• Cotton Wick\n• Eco-conscious coloring\n\nEach candle is handcrafted with care and dipped over 25 times.\n\n𝐖𝐡𝐲 𝐰𝐞 𝐥𝐨𝐯𝐞 𝐛𝐞𝐞𝐬𝐰𝐚𝐱:\n• When burned, beeswax candles emit negative ions that purify the air making it the cleanest burning wax available.\n• When you purchase beeswax products, you are supporting the bee farmers who colonize and encourage bee reproduction.\n• Beeswax naturally smells like honey and wildflowers!\n\n♲ Candles ship in recycled packaging materials.\n\nMade in the USA\n\nUsage: Home Decor, Wedding Centerpieces, Romantic Dinners, Housewarming Gifts, Boutique Displays, Spring Styling, Summer Gatherings, Mother's Day, Elegant Tablescapes, Special Occasions\nNotes: Hand-Dipped, Clean Burning, Beeswax Magic, Cotton Wicks, Non-Toxic, Paraffin Free, Soy Free, Lead Free, Petroleum Free, Paraben Free, Fragrance-Free, Sustainable, Classic Taper Candle, Eco-Friendly",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:58.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
